module.exports = __webpack_public_path__ + "static/media/download-banner.9262a5c1.png";